import React, { Component } from 'react';

import { ILoanAccountActivity } from '../../../interfaces';
import { FormattingUtils } from '../../../utils';

import LoanAccountActivity from './LoanAccountActivity';

const { formatDate, formatMoney } = FormattingUtils;

interface IProps {
  activity: ILoanAccountActivity;
}

/**
 * The loan itself is gone, so this reads off the snapshot the entry carries rather than the loan --
 * see LoanAccountActivity.create_loan_deleted_activity. Labeled as the Loans tab's columns are, the
 * same as the created entry, so the same loan reads the same way wherever it appears.
 */
class LoanDeleted extends Component<IProps> {
  public render () {
    const { data } = this.props.activity
      , activityBody = (
        <div>
          <h3>Loan Deleted</h3>
          <p><span className='status'>Loan Id:</span> {data.loan_vanity_id}</p>
          <p><span className='status'>Initial Principal:</span> {formatMoney(data.initial_principal_amount)}</p>
          <p><span className='status'>Origination:</span> {formatDate(data.origination_date)}</p>
        </div>
      )
      ;

    // Passed explicitly rather than spread, as the other type components are
    return (
      <LoanAccountActivity
        activity={this.props.activity}
        activity_body={activityBody}
        dot='icon'
        icon='trash'
      />
    );
  }
}

export default LoanDeleted;
